import {TYPE} from '../models/type.enum';
import {TYPE_ICON} from '../models/type-icon.enum';
import {TYPE_VALUE_FORM} from '../models/type-value-form.enum';
import {TYPE_DATA} from '../models/table';
import {Observable, of} from 'rxjs';
import {delay, first} from 'rxjs/operators';
import {EventEmitter, Input, Output} from '@angular/core';


export class InBaseFrwComponent {

  id = this.id_crazy;
  isLoading: boolean;
  enum_type = TYPE;
  enum_type_icon = TYPE_ICON;
  enum_type_form = TYPE_VALUE_FORM;
  enum_type_data = TYPE_DATA;

  @Input() hiddenButton = false;
  @Input() delayTimeOnSearch = 400;
  @Input() model = '';

  @Output() delayChange = new EventEmitter();
  @Output() beginSearch = new EventEmitter();
  @Output() actionSearchButton = new EventEmitter();
  inputSearchObservable: Observable<any>;
  firstTime = true;
  private subscriptionList = [];

  printConsole(obj, key?) {
    key && typeof key !== 'undefined' ? console.log(key, obj) : console.log(obj);
  }

  getOnlyKeys(obj) {
    return Object.keys(obj);
  }

  get id_crazy() {
    const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const ID_LENGTH = 12;
    let rtn = '';
    for (let i = 0; i < ID_LENGTH; i++) {
      rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }
    return `id_crazy_${rtn}`;
  }


  filterBySearch() {
    this.unsubscribe();
    this.inputSearchObservable = of(this.model)
      .pipe(
        delay(this.delayTimeOnSearch),
        first()
      );
    const a = this.inputSearchObservable.subscribe(x => {
      this.delayChange.emit(this.model);
      this.beginSearch.emit({isFirstTime: this.firstTime, textSearch: x});
      this.firstTime = false;
    });
    this.subscriptionList.push(a);
  }

  unsubscribe() {
    if (this.subscriptionList && this.subscriptionList.length > 0) {
      this.subscriptionList.forEach(s => {
        if (s) {
          s.unsubscribe();
        }
      });
    }
  }

  searchButton() {
    this.actionSearchButton.emit(this.model);
  }
}
